module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero12.png?c67f51c5";